<template>
  <div>
    <v-text-field
      v-mask="'AA#-#######-##'"
      :masked="false"
      :value="value"
      type="text"
      solo
      clearable
      required
      clear-icon="mdi-close-circle"
      @click:clear="$emit('input',null)"
      :hide-details="errors.length ? false : true"
      :error-messages="errors"
      prepend-inner-icon="mdi-card-text"
      placeholder="xxx-xxxxxxx-xx"
      @input="onInput"
    ></v-text-field>
  </div>
</template>

<script>
  export default {
    props: ['value','errors'],
    data() {
      return {
      }
    },
    methods:{
      onInput(event) {
        if(event) {
          let laser_no = event.replace(/-/g, "");
          this.$emit("input", laser_no);
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>